<button smvd-ui-button icon="sim_card_download" [appearance]="buttonAppearance.Icon" class="u-color-text" (click)="save(data)"></button>
